<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
          title="Attendance Schedule"
          btnTitle="Add New"
          :showBtn="false"
          :showAddNew="true"
          @onClickAddNewButton="onClickAddNewButton"
      />
    </div>
    <div class="my-2 px-2">
        <div class="row">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Branch</label>
          <v-select
              placeholder="Select Branch"
              v-model="branchId"
              :options="branchList"
              label="name"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Department</label>
          <v-select
              placeholder="Select Department"
              v-model="departmentId"
              :options="departmentList"
              label="name"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Designation</label>
          <v-select
              placeholder="Select Designation"
              v-model="designationId"
              :options="designationList"
              label="name"
          />
        </div>
          <div class="col-sm-2 col-md-2 d-flex align-items-end mt-2 action-btn-setter">
            <button
                style="min-width: 64px;"
                @click="onClickToGo"
                class="btn btn-primary btn-block waves-effect waves-float waves-light"
            >Go
            </button>
          </div>
        </div>
    </div>

    <div class="px-2">

    <div class="row align-items-center">
      <div class="col-md-3 col-12 d-flex align-items-start justify-content-start">
        <button
            @click="goToToday"
            class="btn btn-secondary btn-sm"
            :disabled="loading"
        >
          Current
        </button>
      </div>

      <div class="col-md-6 col-12 d-flex align-items-end gap-2">
        <button
            @click="navigatePrevious"
            class="btn btn-outline-primary btn-sm"
            :disabled="loading"
        >
          <i class="bi bi-chevron-left"></i> Previous
        </button>

        <div class="flex-grow-1 text-center">
          <div class="badge bg-light text-dark fs-6 py-1 px-3">
            {{ currentPeriodLabel }}
          </div>
        </div>

        <button
            @click="navigateNext"
            class="btn btn-outline-primary btn-sm"
            :disabled="loading"
        >
          Next <i class="bi bi-chevron-right"></i>
        </button>
      </div>

      <div class="col-md-3 col-12">
        <select
            v-model="viewType"
            @change="onViewTypeChange"
            class="form-select"
        >
          <option
              v-for="type in VIEW_TYPES"
              :key="type.value"
              :value="type.value"
          >
            {{ type.label }}
          </option>
        </select>
      </div>
    </div>
    </div>

    <div class="col-12">
      <div class="card shadow-sm border-0">
        <div class="card-body" style="min-height: 300px">
          <div class="table-responsive border rounded">
            <table class="table table-bordered align-middle text-center mb-0">
              <thead class="table-light">
              <tr>
                <th class="sticky-col">Employee</th>
                <th
                    v-for="date in datePeriods"
                    :key="date"
                    :colspan="policyMasterList.length"
                    class="bg-light fw-semibold text-secondary"
                >
                  {{ formatDate(date) }}
                </th>
              </tr>
              <tr>
                <th class="sticky-col"></th>
                <template v-for="date in datePeriods" :key="date">
                  <th class="shift-header morning"
                      v-for="shift in policyMasterList"
                      :key="date + '_' + shift.id"
                  >
                     {{ shift.name }} <br>
                  </th>
                </template>
              </tr>
              </thead>

              <tbody>
              <tr v-for="emp in contactProfileList.data" :key="emp.id">
                <td class="bg-light fw-medium sticky-col">
                  {{ emp.name }}({{ emp.serial_no }})
                </td>

                <template v-for="date in datePeriods" :key="date">
                  <td
                      v-for="shift in policyMasterList"
                      :key="shift.id + date"
                      class="text-center"
                  >
                <span
                    v-for="schedule in emp.schedule_data"
                    :key="schedule.attendance_policy_general_id"
                >
                  <div
                      v-if="
                      schedule.date === date &&
                      schedule.attendance_policy_master_id === shift.id
                    "
                      class="schedule-item bg-primary"
                  >
                    <p class="m-0 p-0 text-white">
                      {{ schedule.label }}
                    </p>
                  </div>
                </span>
                  </td>
                </template>
              </tr>
              </tbody>
            </table>
            <p v-if="contactProfileList.length < 1">No Data Found</p>
          </div>

        </div>
      </div>
    </div>

    <div class="px-2 position-absolute bottom-0 mt-4">
      <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
    </div>

    <Loader v-if="loading"/>

  </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import handleDropdowns from "@/services/modules/dropdowns";
import Pagination from '@/components/atom/Pagination'

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const contactProfileList = ref([]);
const policyMasterList = ref([]);
const datePeriods = ref([])
const branchId = ref('');
const departmentId = ref('');
const designationId = ref('');
let departmentList = ref([])
let branchList = ref([])
let designationList = ref([])
const viewType = ref('weekly');
const currentDate = ref(new Date());
const params = ref({
  offset: 20,
});
const token = computed(() => localStorage.getItem('token'));

const {
  fetchAttendanceScheduleList
} = handleHrPayroll()
const { fetchDropdownList } = handleDropdowns()

function onClickAddNewButton() {
  router.push({name: `attendance-schedule-add`, params: route.params, query: route.query})
}

const VIEW_TYPE_VALUES = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly'
};

const VIEW_TYPES = [
  {
    value: VIEW_TYPE_VALUES.DAILY,
    label: 'Daily'
  },
  {
    value: VIEW_TYPE_VALUES.WEEKLY,
    label: 'Weekly'
  },
  {
    value: VIEW_TYPE_VALUES.MONTHLY,
    label: 'Monthly'
  }
];

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getAttendanceScheduleData();
}


const currentPeriodLabel = computed(() => {
  const date = currentDate.value;

  if (viewType.value === VIEW_TYPE_VALUES.DAILY) {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  if (viewType.value === VIEW_TYPE_VALUES.WEEKLY) {
    const startOfWeek = getStartOfWeek(date);
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(endOfWeek.getDate() + 6);

    return `${formatDateShort(startOfWeek)} - ${formatDateShort(endOfWeek)}`;
  }

  if (viewType.value === VIEW_TYPE_VALUES.MONTHLY) {
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long'
    });
  }

  return '';
});

const formatDate = (date) => {
  const d = new Date(date);
  const dayName = d.toLocaleDateString("en-GB", { weekday: "short" });
  const formatted = d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "2-digit",
  });

  return `${formatted}, ${dayName}`;
};

const onClickToGo = () => {
  getAttendanceScheduleData();
}

const getAttendanceScheduleData = async () => {
  const query = getQuery();
  loading.value = true
  contactProfileList.value = []
  policyMasterList.value = []
  datePeriods.value = []

  await fetchAttendanceScheduleList(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    let data = res.data;
    contactProfileList.value = data.contact_profiles;
    policyMasterList.value = data.attendance_policy_master;
    datePeriods.value = data.periods;
    setPagination(data.contact_profiles)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getQuery = () => {
  let query = `?company_id=${route.params.companyId}`;

  const date = currentDate.value;
  let startDate, endDate;

  if (viewType.value === VIEW_TYPE_VALUES.DAILY) {
    startDate = formatDateForAPI(date);
    endDate = formatDateForAPI(date);
  }

  if (viewType.value === VIEW_TYPE_VALUES.WEEKLY) {
    const startOfWeek = getStartOfWeek(date);
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(endOfWeek.getDate() + 6);

    startDate = formatDateForAPI(startOfWeek);
    endDate = formatDateForAPI(endOfWeek);
  }

  if (viewType.value === VIEW_TYPE_VALUES.MONTHLY) {
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    startDate = formatDateForAPI(startOfMonth);
    endDate = formatDateForAPI(endOfMonth);
  }

  query += '&start_date=' + startDate;
  query += '&end_date=' + endDate;
  if (branchId.value) query += '&branch_id=' + branchId.value.id;
  if (departmentId.value) query += '&department_id=' + departmentId.value.id;
  if (designationId.value) query += '&designation_id=' + designationId.value.id;
  query += '&offset=' + params.value.offset;
  if (route.query.page) query += '&page=' + route.query.page;
  return query;
}

const updateRouteQuery = () => {
  const date = currentDate.value;
  let startDate, endDate;

  if (viewType.value === VIEW_TYPE_VALUES.DAILY) {
    startDate = formatDateForAPI(date);
    endDate = formatDateForAPI(date);
  }
  if (viewType.value === VIEW_TYPE_VALUES.WEEKLY) {
    const startOfWeek = getStartOfWeek(date);
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(endOfWeek.getDate() + 6);

    startDate = formatDateForAPI(startOfWeek);
    endDate = formatDateForAPI(endOfWeek);
  }

  if (viewType.value === VIEW_TYPE_VALUES.MONTHLY) {
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    startDate = formatDateForAPI(startOfMonth);
    endDate = formatDateForAPI(endOfMonth);
  }

  router.push({
    query: {
      ...route.query,
      start: startDate,
      end: endDate,
      view: viewType.value
    }
  });
};

const navigatePrevious = () => {
  const date = new Date(currentDate.value);

  if (viewType.value === VIEW_TYPE_VALUES.DAILY) {
    date.setDate(date.getDate() - 1);
  }
  if (viewType.value === VIEW_TYPE_VALUES.WEEKLY) {
    date.setDate(date.getDate() - 7);
  }
  if (viewType.value === VIEW_TYPE_VALUES.MONTHLY) {
    date.setMonth(date.getMonth() - 1);
  }

  currentDate.value = date;
  updateRouteQuery();
  getAttendanceScheduleData();
};

const navigateNext = () => {
  const date = new Date(currentDate.value);

  if (viewType.value === VIEW_TYPE_VALUES.DAILY) {
    date.setDate(date.getDate() + 1);
  }
  if (viewType.value === VIEW_TYPE_VALUES.WEEKLY) {
    date.setDate(date.getDate() + 7);
  }
  if (viewType.value === VIEW_TYPE_VALUES.MONTHLY) {
    date.setMonth(date.getMonth() + 1);
  }

  currentDate.value = date;
  updateRouteQuery();
  getAttendanceScheduleData();
};

const goToToday = () => {
  currentDate.value = new Date();
  updateRouteQuery();
  getAttendanceScheduleData();
};

const onViewTypeChange = () => {
  updateRouteQuery();
  getAttendanceScheduleData();
};

const getStartOfWeek = (date) => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day;
  return new Date(d.setDate(diff));
};

const formatDateShort = (date) => {
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

const formatDateForAPI = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getDropdownList = async () => {
  let query = getQuery();
  query += '&is_branch=1&is_department=1&is_designation=1'

  branchList.value = []
  departmentList.value = []

  await fetchDropdownList(query).then(res => {
    if (!res.status){
      return
    }

    let data = res.data;
    branchList.value = data.branch_list;
    departmentList.value = data.department_list;
    designationList.value = data.designation_list;
  }).catch(err => {
    console.log(err)
  })
}

onMounted(() => {
  Promise.all([
    getDropdownList(),
    getAttendanceScheduleData()
  ])
})

</script>

<style scoped>
.sticky-col {
  position: sticky;
  left: 0;
  z-index: 10;
  background: white;
}

.schedule-item {
  cursor: move;
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  transition: opacity 0.2s;
}

.schedule-item:hover {
  background-color: #e9ecef;
}

.table-responsive {
  max-height: 600px;
  overflow: auto;
}

.shift-header {
  min-width: 120px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>